module.exports = __webpack_public_path__ + "static/media/notes_icon4.1bf0fcdb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notes/notes_icon4.svg
// module id = 198
// module chunks = 0